
import styled from 'styled-components';

const Intro = styled.div`
    padding: 10px 20px;
`;

const Introduction = () => {
return (
  <Intro>
    <h2>EIC: Area codes map view</h2>
    <p>The purpose of the tool here is to find the area for which an EIC code represents. You may filter by EIC Function Type.</p>
    <p>No map will be displayed for areas for areas that we do not have a geographic shape for.</p>
    <p>Data is sourced from the Area Codes (Y) as published at <a href="https://www.entsoe.eu/data/energy-identification-codes-eic/eic-approved-codes/">ENTSO-E EIC Codes</a></p>
  </Intro>
)
}

export default Introduction